module.exports = __webpack_public_path__ + "img/FremontLofts-1014-003.1dfd838c.jpg";